import React, { createContext, useContext, useEffect, useState } from 'react';
import moment from 'moment';

import { ProfileContext } from '../profile/profile.context';
import {
  accessTokenRequest,
  getUserData,
  sendRequest,
} from '../global/global.service';
import { urlConfig } from '../../config/urlConfig';

export const MeetingDetailsContext = createContext();

export const MeetingDetailsContextProvider = ({ children }) => {
  const { user } = useContext(ProfileContext);
  const [meeting, setMeeting] = useState('');
  const [isInThePast, setIsInThePast] = useState('');
  const [meetingUsers, setMeetingUsers] = useState([]);
  const [error, setError] = useState('');
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isCopy, setIsCopy] = useState(false);

  useEffect(() => {
    let status = moment().utc().format() > meeting.end_date_time;
    meeting && setIsInThePast(status);
  }, [meeting]);

  const dateTime = (date) => moment(date).format('YYYY-MM-DD HH:mm');

  const meetingLink = (link) => {
    const prefix1 = 'https://';
    const prefix2 = 'https://';

    let url = '';
    if (link.substr(0, prefix1.length) !== prefix1) {
      url = prefix1 + link;
    } else if (link.substr(0, prefix2.length) !== prefix2) {
      url = prefix2 + link;
    } else {
      url = link;
    }
    return encodeURI(url);
  };

  const copyLink = () => {
    const pathname = window.location.href;
    navigator.clipboard.writeText(pathname);
    setIsCopy(true);

    setTimeout(() => {
      setIsCopy(false);
    }, 1000);
  };

  const getMeeting = (id, setLoading) => {
    accessTokenRequest()
      .then((response) => {
        sendRequest(
          `${urlConfig.meeting_url}${parseInt(id)}/`,
          response,
          'get',
          null
        )
          .then((res) => {
            setMeeting(res.data);
            getUsersData(res.data);
            checkHostStatus(res.data);
            setLoading && setLoading(false);
          })
          .catch((err) => {
            console.log('get token err', err);
            setError(`Meeting not found!`);
            setLoading && setLoading(false);

            err.response &&
              err.response &&
              err.response.data &&
              console.log(err.response.data);
          });
      })
      .catch((err) => {
        console.log('get token err', err);
        setLoading && setLoading(false);
      });
  };

  const getUsersData = (data) => {
    const users_uuids =
      data &&
      data.members
        .filter((item) => item.member_uuid !== null)
        .map((i) => i.member_uuid);

    if (users_uuids && users_uuids.length > 0) {
      accessTokenRequest()
        .then((response) => {
          getUserData(
            {
              users_uuids,
            },
            response
          ).then((res) => {
            setMeetingUsers(res.data.members);
            addNoneMembers(data, res.data.members);
          });
        })
        .catch((e) => {
          console.log('users data error', e.response);
        });
    }
  };

  const addNoneMembers = (meeting, users) => {
    const non_member = meeting.members
      .filter((item) => item.member_uuid === null)
      .map((i) => i);

    let newArr = [];

    if (non_member && non_member.length > 0) {
      non_member.map((i) =>
        newArr.push({
          email: i.email,
          meeting: i.meeting,
          member_uuid: null,
          status: i.status,
        })
      );
      setMeetingUsers([...users, ...newArr]);
    }
  };

  const chooseMeetingStatus = (status, url) => {
    setLoading(true);
    accessTokenRequest()
      .then((response) => {
        sendRequest(
          `${urlConfig.meeting_url}${meeting.id}/${url}/`,
          response,
          'post',
          null
        )
          .then((res) => {
            setStatus(status);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err.response);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
      });
  };

  const checkHostStatus = (meeting) => {
    if (meeting.members && meeting.members.length > 0) {
      const hostUid = meeting.members
        .filter((item) => item.member_uuid === user.uid)
        .map((user) => user);

      hostUid &&
        hostUid.length > 0 &&
        setStatus(hostUid[0].status !== null ? hostUid[0].status : null);
    }
  };

  const requestToJoin = () => {
    setLoading(true);
    accessTokenRequest()
      .then((response) => {
        sendRequest(
          `${urlConfig.meeting_url}${meeting.id}/join/`,
          response,
          'post',
          null
        )
          .then((res) => {
            setStatus(4);
            setLoading(false);
          })
          .catch((err) => {
            console.log(err.response);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
      });
  };

  const selectRequest = (status, setLoading, member_uuid, id) => {
    const url = {
      0: 'hostaccept',
      1: 'hostreject',
    };

    setLoading(true);
    accessTokenRequest()
      .then((response) => {
        sendRequest(
          `${urlConfig.meeting_url}${meeting.id}/${url[status]}/`,
          response,
          'post',
          {
            member_uuid,
          }
        )
          .then((res) => {
            getMeeting(id, setLoading);
          })
          .catch((err) => {
            console.log(err.response);
            setLoading(false);
          });
      })
      .catch((err) => {
        console.log(err.response);
        setLoading(false);
      });
  };

  const states = {
    meeting,
    status,
    error,
    loading,
    isCopy,
    isInThePast,
    meetingUsers,
    setStatus,
    setMeeting,
  };

  const functions = {
    copyLink,
    meetingLink,
    dateTime,
    getMeeting,
    checkHostStatus,
    chooseMeetingStatus,
    getUsersData,
    requestToJoin,
    selectRequest,
  };

  return (
    <MeetingDetailsContext.Provider
      value={{
        states,
        functions,
      }}
    >
      {children}
    </MeetingDetailsContext.Provider>
  );
};
